module.exports = __webpack_public_path__ + "img/2025-0416-02-02.a03e39ea.png";